import React from 'react';

const Contact = () => {
  return (
    <div className="px-4 py-12 bg-gray-100">
      <div className="container grid items-start max-w-6xl gap-12 mx-auto md:grid-cols-2">
        {/* Contact Form */}
        <div className="w-full max-w-lg">
          <h2 className="mb-4 text-3xl font-semibold text-gray-900">How can we help you</h2>
          <p className="mb-8 text-gray-700">
            Whether you’re a parent, guardian, or partner — we’re here to answer your questions and guide you through our school journey.
          </p>
          <form
            action="https://fabform.io/f/{your-form-id}"
            method="POST"
            className="px-6 py-8 space-y-4 bg-white rounded-lg shadow-md"
          >
            <div>
              <label htmlFor="name" className="block mb-2 font-bold text-gray-700">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Enter your name"
                required
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="email" className="block mb-2 font-bold text-gray-700">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Enter your email"
                required
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded focus:outline-none focus:shadow-outline"
              />
            </div>
            <div>
              <label htmlFor="message" className="block mb-2 font-bold text-gray-700">Message</label>
              <textarea
                id="message"
                name="message"
                rows="6"
                placeholder="Enter your message"
                required
                className="w-full px-3 py-2 leading-tight text-gray-700 border rounded focus:outline-none focus:shadow-outline"
              />
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700 focus:outline-none focus:shadow-outline"
              >
                Send
              </button>
            </div>
            <a
              href="https://veilmail.io/e/FkKh7o"
              className="block mt-4 text-sm text-blue-600 hover:underline"
              target="_blank" rel="noopener noreferrer"
            >
              Or click here to reveal our protected email address
            </a>
          </form>
        </div>

        {/* Google Map */}
        <div className="w-full h-[450px] shadow-md rounded-lg overflow-hidden">
          <iframe
            title="Blessed Montessori Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.7160287482356!2d3.3792054152482737!3d6.524379025196777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103bf44d4531e3f5%3A0x435e7e25fffeec3!2sLagos%20Island!5e0!3m2!1sen!2sng!4v1629999999999!5m2!1sen!2sng"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            className="w-full h-full border-0"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
